import { Checkbox as BaseCheckbox, CheckboxProps, forwardRef } from '@chakra-ui/react';
import React from 'react';

// eslint-disable-next-line react/display-name
const Checkbox = forwardRef<CheckboxProps, 'input'>(({ children, ...props }, ref) => {
  return (
    <BaseCheckbox ref={ref} size="lg" colorScheme="pink" fontSize="16px" {...props}>
      {children}
    </BaseCheckbox>
  );
});

export default Checkbox;
